import React from 'react';

const MENU = [
  { key: 'analytics', label: 'Analytics' },
  { key: 'games', label: 'Games' },
  { key: 'settings', label: 'Settings' },
];

const TabBar = ({ openTabs, activeTab, setActiveTab, closeTab }) => (
  <div className="tab-bar">
    {openTabs.map((tab, idx) => (
      <div
        key={tab}
        className={`tab-bar-tab${activeTab === tab ? ' active' : ''}`}
        onClick={() => setActiveTab(tab)}
        style={{ fontSize: '0.77rem', minHeight: 24, height: 24, padding: '0 6px', marginRight: 4 }}
      >
        <span style={{ flex: 1 }}>{MENU.find(m => m.key === tab)?.label}</span>
        {openTabs.length > 1 && (
          <span
            className="tab-bar-close"
            onClick={e => { e.stopPropagation(); closeTab(tab); }}
            style={{ marginLeft: 8, fontSize: '1rem', lineHeight: 1, display: 'inline-block', verticalAlign: 'middle' }}
          >
            ×
          </span>
        )}
      </div>
    ))}
  </div>
);

export default TabBar; 